import styled from '@emotion/styled';

import { Badge } from '@/design-system';

export const ShrinkWrapper = styled('span')({
  display: 'inline-flex',
  flex: '0 1 auto',
  minWidth: 0,
  maxWidth: '100%',
});

export const TruncatedBadge = styled(Badge)({
  display: 'inline-block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const TooltipPath = styled('span')({
  overflowWrap: 'anywhere',
});

export const TooltipPathLeaf = styled('span', {
  shouldForwardProp: (prop) => prop !== '$color',
})<{ $color: string }>(({ $color }) => ({
  color: $color,
}));
